<ng-container *ngIf="count < +text.length; else baseTmp">
  {{ showMore ? text : (text | slice: 0 : count) + (count === 0 ? "" : "...")
  }}<a class="text-nowrap ms-1 d-inline-block" [ngClass]="'color-' + color" (click)="showMore = !showMore">
    {{
      showMore
        ? ("hide" | translate) + entityName
        : count === 0
          ? ("show" | translate) + entityName
          : ("show_more" | translate)
    }}
  </a>
</ng-container>
<ng-template #baseTmp>
  {{ text }}
</ng-template>
